module.exports = __webpack_public_path__ + "static/media/mcbride_delama_thomas_sweeney.e6526ace.jpg";